import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "p-the-page-m14__form c-form-inner" }
const _hoisted_2 = ["onMouseenter"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "p-form-radio-group" }
const _hoisted_5 = { class: "p-help-modal__body" }
const _hoisted_6 = {
  key: 1,
  style: {"margin-top":"12px"}
}
const _hoisted_7 = { "data-translate-skip": "" }
const _hoisted_8 = { class: "p-form-radio-group" }
const _hoisted_9 = {
  key: 2,
  class: "p-form-button-group"
}
const _hoisted_10 = {
  key: 0,
  class: "p-form-button-group__vertical"
}
const _hoisted_11 = { class: "p-form-button-group__vertical" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingContent = _resolveComponent("LoadingContent")!
  const _component_FormLabel = _resolveComponent("FormLabel")!
  const _component_InputRadio = _resolveComponent("InputRadio")!
  const _component_ValidationErrorText = _resolveComponent("ValidationErrorText")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_Form = _resolveComponent("Form")!
  const _component_TheTemplateM = _resolveComponent("TheTemplateM")!
  const _component_ModalMain = _resolveComponent("ModalMain")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_TheTemplateM, { class: "p-the-page-m14" }, {
      heading: _withCtx(() => _cache[4] || (_cache[4] = [
        _createTextVNode("メール受信設定", -1)
      ])),
      body: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_LoadingContent, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Form, {
            onSubmit: _withModifiers(_ctx.submit, ["prevent"])
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedWantMailList, (wantMailData, key) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: key,
                  class: "p-form-group p-form-group--near"
                }, [
                  (wantMailData.show)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_FormLabel, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(wantMailData.label) + " ", 1),
                            (wantMailData.tooltip)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "p-mail-help-wrapper",
                                  onMouseenter: ($event: any) => (_ctx.showTooltipPc(wantMailData.key)),
                                  onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideTooltipPc && _ctx.hideTooltipPc(...args)))
                                }, [
                                  _createElementVNode("div", {
                                    class: "p-mail-help",
                                    onClick: _withModifiers(($event: any) => (_ctx.toggleTooltip(wantMailData.key)), ["stop"])
                                  }, " ⓘ ", 8, _hoisted_3),
                                  (_ctx.activeTooltipKey === wantMailData.key && !_ctx.isSp)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "p-mail-help__tooltip",
                                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                                      }, _toDisplayString(wantMailData.tooltip), 1))
                                    : _createCommentVNode("", true)
                                ], 40, _hoisted_2))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_Field, {
                            name: wantMailData.key
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputRadio, _mergeProps({ ref_for: true }, field, {
                                modelValue: _ctx.wantMail[wantMailData.key],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.wantMail[wantMailData.key]) = $event),
                                value: '1',
                                error: errors[0]
                              }), {
                                default: _withCtx(() => _cache[5] || (_cache[5] = [
                                  _createTextVNode("希望する", -1)
                                ])),
                                _: 2,
                                __: [5]
                              }, 1040, ["modelValue", "onUpdate:modelValue", "error"]),
                              _createVNode(_component_InputRadio, _mergeProps({ ref_for: true }, field, {
                                modelValue: _ctx.wantMail[wantMailData.key],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.wantMail[wantMailData.key]) = $event),
                                value: '2',
                                error: errors[0]
                              }), {
                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                  _createTextVNode("希望しない", -1)
                                ])),
                                _: 2,
                                __: [6]
                              }, 1040, ["modelValue", "onUpdate:modelValue", "error"]),
                              (errors[0])
                                ? (_openBlock(), _createBlock(_component_ValidationErrorText, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(errors[0]), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["name"])
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              (_ctx.activeTooltipKey && _ctx.isSp)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "p-help-modal-overlay",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTooltipKey = ''))
                  }, [
                    _createElementVNode("div", {
                      class: "p-help-modal",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.activeTooltipText), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isGroupBudgetMailHiddenUser && _ctx.roleType == '4' && _ctx.isGroupBudget)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wantMailListForGroupBudget, (wantMailDataForGroupBudget, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: key,
                        class: "p-form-group p-form-group--near"
                      }, [
                        (wantMailDataForGroupBudget.show)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_FormLabel, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.groupBudgetName), 1),
                                  _createTextVNode(_toDisplayString(wantMailDataForGroupBudget.label), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_Field, {
                                  name: wantMailDataForGroupBudget.key
                                }, {
                                  default: _withCtx(({ field, errors }) => [
                                    _createVNode(_component_InputRadio, _mergeProps({ ref_for: true }, field, {
                                      modelValue: _ctx.wantMail[wantMailDataForGroupBudget.key],
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.wantMail[wantMailDataForGroupBudget.key]) = $event),
                                      value: "1",
                                      error: errors[0]
                                    }), {
                                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                                        _createTextVNode("希望する", -1)
                                      ])),
                                      _: 2,
                                      __: [7]
                                    }, 1040, ["modelValue", "onUpdate:modelValue", "error"]),
                                    _createVNode(_component_InputRadio, _mergeProps({ ref_for: true }, field, {
                                      modelValue: _ctx.wantMail[wantMailDataForGroupBudget.key],
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.wantMail[wantMailDataForGroupBudget.key]) = $event),
                                      value: "2",
                                      error: errors[0]
                                    }), {
                                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                                        _createTextVNode("希望しない", -1)
                                      ])),
                                      _: 2,
                                      __: [8]
                                    }, 1040, ["modelValue", "onUpdate:modelValue", "error"]),
                                    (errors[0])
                                      ? (_openBlock(), _createBlock(_component_ValidationErrorText, { key: 0 }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(errors[0]), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["name"])
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_ctx.hasUpdate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(_component_ButtonMain, { type: "submit" }, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                              _createTextVNode("保存", -1)
                            ])),
                            _: 1,
                            __: [9]
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_ButtonMain, {
                        tag: "a",
                        href: "/home/",
                        kind: "cancel"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.buttonTitle), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ])
      ]),
      _: 1
    }),
    (_ctx.modalName === 'mailDeliverySettingsUpdated')
      ? (_openBlock(), _createBlock(_component_ModalMain, { key: 0 }, {
          head: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode(" メール受信設定の変更が ", -1),
            _createElementVNode("br", null, null, -1),
            _createTextVNode("完了しました。 ", -1)
          ])),
          body: _withCtx(() => [
            _createVNode(_component_ButtonMain, {
              kind: "cancel",
              onClick: _ctx.closeModal
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("OK", -1)
              ])),
              _: 1,
              __: [11]
            }, 8, ["onClick"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}